// 2024 Primal Champion (Barbarian 20): Strength and Constitution increase by 4, to a maximum of 25; Body and Mind (Monk 20)
// does the same for Dexterity and Wisdom. Plain CommonJS so the server's synchronous ability-score code and the client
// share one rule.
const PRIMAL_CHAMPION_LEVEL = 20;
const PRIMAL_CHAMPION_ABILITIES = ['str', 'con'];
const PRIMAL_CHAMPION_MAXIMUM = 25;

const BODY_AND_MIND_ABILITIES = ['dex', 'wis'];

const classLevel = (character, classId) => (Array.isArray(character?.occupation) ? character.occupation : []).reduce((total, entry) => {
  const name = String(entry?.Name ?? entry?.Occupation ?? entry?.name ?? entry?.occupation ?? entry?.class ?? '').trim().toLowerCase();
  const level = Number(entry?.Level ?? entry?.level ?? 0);
  return name === classId && Number.isFinite(level) && level > 0 ? total + level : total;
}, 0);
const barbarianLevel = (character) => classLevel(character, 'barbarian');

/** The score with Primal Champion applied: +4 to Strength or Constitution for a level 20 Barbarian, up to 25. */
function withPrimalChampion(character, ability, score) {
  if (!PRIMAL_CHAMPION_ABILITIES.includes(ability) || barbarianLevel(character) < PRIMAL_CHAMPION_LEVEL) return score;
  return Math.max(score, Math.min(PRIMAL_CHAMPION_MAXIMUM, score + 4));
}

/** The score with Body and Mind applied: +4 to Dexterity or Wisdom for a level 20 Monk, up to 25. */
function withBodyAndMind(character, ability, score) {
  if (!BODY_AND_MIND_ABILITIES.includes(ability) || classLevel(character, 'monk') < PRIMAL_CHAMPION_LEVEL) return score;
  return Math.max(score, Math.min(PRIMAL_CHAMPION_MAXIMUM, score + 4));
}

/** Both level 20 increases (they raise different scores). */
const withCapstoneScores = (character, ability, score) => withBodyAndMind(character, ability, withPrimalChampion(character, ability, score));

module.exports = { PRIMAL_CHAMPION_LEVEL, PRIMAL_CHAMPION_MAXIMUM, barbarianLevel, withPrimalChampion, withBodyAndMind, withCapstoneScores };
